import { useNavigate } from 'react-router-dom';
import AuthShell from '@/pages/auth/components/AuthShell';
import Button from '@/components/base/Button';

export default function UnderReviewPage() {
  const navigate = useNavigate();

  return (
    <AuthShell brandHeadline="شريكك في تقديم أفضل خدمة">
      <div className="text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-success-50">
          <i className="ri-checkbox-circle-fill text-4xl text-success-500" aria-hidden="true"></i>
        </div>

        <h1 className="mt-5 font-bold text-2xl text-foreground-950">تم إرسال طلبك بنجاح!</h1>
        <p className="mt-3 text-sm leading-relaxed text-foreground-500">
          سيتم مراجعة طلبك والرد عليك خلال 24-48 ساعة عبر البريد الإلكتروني
        </p>

        <div className="mt-6 flex items-start gap-3 rounded-card border border-accent-200 bg-accent-50 px-4 py-3 text-right">
          <i className="ri-time-line mt-0.5 text-lg text-accent-600" aria-hidden="true"></i>
          <div>
            <p className="font-semibold text-[13px] text-foreground-900">طلبك قيد المراجعة</p>
            <p className="mt-0.5 text-[12px] leading-relaxed text-foreground-600">
              سيصلك إشعار بالنتيجة على بريدك الإلكتروني. في حال القبول يمكنك تسجيل الدخول والبدء في
              إعداد خدماتك.
            </p>
          </div>
        </div>

        <div className="mt-6 rounded-card border border-background-200 bg-background-50 p-4 text-right">
          <p className="mb-3 font-semibold text-[13px] text-foreground-900">خطوات المراجعة</p>
          <ul className="space-y-3">
            <li className="flex items-center gap-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-success-500 text-white">
                <i className="ri-check-line text-sm" aria-hidden="true"></i>
              </span>
              <span className="text-[13px] text-foreground-700">تم استلام الطلب والمستندات</span>
            </li>
            <li className="flex items-center gap-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-500 text-foreground-950">
                <i className="ri-search-eye-line text-sm" aria-hidden="true"></i>
              </span>
              <span className="text-[13px] font-medium text-foreground-900">
                مراجعة البيانات من فريق الإدارة
              </span>
            </li>
            <li className="flex items-center gap-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-200 text-foreground-400">
                <i className="ri-mail-check-line text-sm" aria-hidden="true"></i>
              </span>
              <span className="text-[13px] text-foreground-500">إرسال النتيجة على بريدك</span>
            </li>
          </ul>
        </div>

        <div className="mt-6">
          <Button
            type="button"
            variant="outline"
            size="lg"
            fullWidth
            icon="ri-arrow-right-line"
            onClick={() => navigate('/auth/login')}
          >
            العودة لتسجيل الدخول
          </Button>
        </div>
      </div>
    </AuthShell>
  );
}